import { MultiPolygon, Polygon } from 'src/common-services'

export enum Borders {
  NONE = 'none',
  ZIP_CODES = 'Zip Codes',
  NEIGHBORHOODS = 'Neighborhoods',
  CITIES = 'Cities',
  PARCEL_BOUNDARIES = 'Parcel Boundaries',
  CENSUS_BLOCK_GROUPS = 'Census Block Groups',
}

export type BorderData = {
  name: string
  polygon: MultiPolygon | Polygon
}
